function handleClick(e) {
  if (e.target.nodeName === 'BUTTON') {
    const button = e.target;
    const quantityElement = this.querySelector('input[name="quantity"]');
    if (button.getAttribute('data-type') === 'plus') {
      quantityElement.value = parseInt(quantityElement.value, 10) + 1;
    } else if (
      button.getAttribute('data-type') === 'minus' &&
      parseInt(quantityElement.value, 10) > 1
    ) {
      quantityElement.value = parseInt(quantityElement.value, 10) - 1;
    }
  }
}

export default function init(options) {
  const config = {
    incrementer: document.querySelectorAll('[data-module="incrementer"]')
  };

  Object.keys(options).forEach(key => {
    config[key] = options[key];
  });

  if (config.incrementer !== null && config.incrementer.length > 0) {
    for (let i = 0; i < config.incrementer.length; i += 1) {
      config.incrementer[i].addEventListener('click', handleClick, false);
    }
  }
}
